var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-success"},[_c('i',{staticClass:"main-icon icon ion-md-checkmark"}),_vm._m(0),_c('button',{staticClass:"yes theme-button-outline",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(" אישור ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"main-text"},[_vm._v(" בקשתך נקלטה בהצלחה "),_c('br'),_vm._v(" ניצור איתך קשר בהקדם ")])
}]

export { render, staticRenderFns }